import { StyleSheet, Platform } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'
import { LANDING_NEW_NAV_CTA_LEFT_CONTROL_HEIGHT } from '../../../src/landing/constants/landingNewNavCta.constants'

export function getLandingSignedInControlsStyles(theme: Theme, isDark: boolean) {
  const frostedLightBg = 'rgba(255, 255, 255, 0.72)'
  const frostedLightBorder = 'rgba(159, 122, 234, 0.24)'
  const frostedLightDivider = 'rgba(159, 122, 234, 0.22)'
  const frostedLightSignOutBg = 'rgba(255, 255, 255, 0.42)'

  return StyleSheet.create({
    accountControl: {
      flexDirection: 'row',
      alignItems: 'center',
      height: LANDING_NEW_NAV_CTA_LEFT_CONTROL_HEIGHT,
      maxWidth: 234,
      borderRadius: 999,
      backgroundColor: isDark ? theme.background.cardElevated : frostedLightBg,
      borderWidth: 1,
      borderColor: isDark ? theme.gray[400] : frostedLightBorder,
      overflow: 'hidden',
    },
    accountPill: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 7,
      flex: 1,
      alignSelf: 'stretch',
      minWidth: 0,
      paddingVertical: 4,
      paddingLeft: 8,
      paddingRight: 10,
    },
    accountAvatar: {
      width: 24,
      height: 24,
      borderRadius: 12,
      backgroundColor: theme.primaryDark,
      alignItems: 'center',
      justifyContent: 'center',
    },
    accountAvatarText: {
      fontFamily: Platform.OS === 'web' ? '"Inter", system-ui, sans-serif' : undefined,
      color: '#FFFFFF',
      fontSize: 11,
      fontWeight: '800',
    },
    accountCopy: {
      flex: 1,
      minWidth: 0,
    },
    accountKicker: {
      fontFamily: Platform.OS === 'web' ? '"Inter", system-ui, sans-serif' : undefined,
      fontSize: 9,
      lineHeight: 10,
      color: theme.gray[600],
      fontWeight: '700',
      textTransform: 'uppercase',
      letterSpacing: 0.5,
    },
    accountName: {
      fontFamily: Platform.OS === 'web' ? '"Inter", system-ui, sans-serif' : undefined,
      fontSize: 11,
      lineHeight: 14,
      color: theme.gray[900],
      fontWeight: '700',
    },
    signOutBtn: {
      alignItems: 'center',
      justifyContent: 'center',
      width: 40,
      alignSelf: 'stretch',
      borderLeftWidth: 1,
      borderLeftColor: isDark ? theme.gray[400] : frostedLightDivider,
      backgroundColor: isDark ? theme.background.card : frostedLightSignOutBg,
    },
    signOutBtnHovered: {
      backgroundColor: isDark ? theme.background.shell : '#FFFFFF',
    },
  })
}
